import { BusinessAndPeopleSectionType } from './BusinessAndPeopleSectionType';
import { FeatureType } from '@apply/constants';

export const BusinessAndPeopleSectionTypeOptions = [
    {
        id: BusinessAndPeopleSectionType.BorrowerEntities,
        text: 'Borrower Entities',
        dashboardText: 'Borrower Entities',
        featureFlag: FeatureType.BPHierarchyPhase2,
    },
    {
        id: BusinessAndPeopleSectionType.OwnersOfBorrowerEntities,
        text: 'Owner(s) of Borrower Entities',
        dashboardText: 'Owner(s) of Borrow. Entities',
        featureFlag: FeatureType.BPHierarchyPhase2,
    },
    {
        id: BusinessAndPeopleSectionType.OwnersOfOtherEntities,
        text: 'Owner(s) of Other Entities',
        dashboardText: 'Owner(s) of Other Entities',
        featureFlag: FeatureType.BPHierarchyPhase2,
    },
    {
        id: BusinessAndPeopleSectionType.S1Uploads,
        text: 'S1 Uploads',
        dashboardText: 'S1 Uploads',
        featureFlag: FeatureType.BPHierarchyPhase3,
    },
    {
        id: BusinessAndPeopleSectionType.AdditionalPeople,
        text: 'Additional People',
        dashboardText: 'Additional People',
        featureFlag: FeatureType.BPHierarchyPhase2,
    },
    {
        id: BusinessAndPeopleSectionType.GeneralContractors,
        text: 'General Contractors',
        dashboardText: 'General Contractors',
        featureFlag: FeatureType.BPHierarchyPhase2,
    },
    {
        id: BusinessAndPeopleSectionType.VerifyCompanyStructure,
        text: 'Verify Company Structure',
        dashboardText: 'Verify Company Structure',
        featureFlag: FeatureType.BPHierarchyPhase3,
    },
    {
        id: BusinessAndPeopleSectionType.LicenseToBuild,
        text: 'License To Build',
        featureFlag: FeatureType.BPHierarchyPhase2,
    },
    {
        id: BusinessAndPeopleSectionType.References,
        text: 'References',
        featureFlag: FeatureType.BPHierarchyPhase2,
    },
];
